import React, { useState, useEffect, useCallback, useRef, Fragment } from 'react'
import AdProServices from '../../../Api/AdPro/AdProServices'
import { Autocomplete, Box, Button, Chip, Collapse, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import Colors from '../../../Assets/Styles/Colors';
import moment from 'moment';
import { Edit, FilterAltTwoTone, KeyboardArrowLeft, KeyboardArrowRight, RemoveRedEye, VolumeOffSharp } from '@mui/icons-material';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';
import SelectField from '../../../Components/Fields/SelectField';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import ServicesServices from '../../../Api/AdBazar/Services/ServicesServices';
import IndustriesServices from '../../../Api/AdBazar/Industries/IndustriesServices';

const tableHead = [
  "Name",
  "Contact",
  "Email",
  "Service",
  "Industry",
  "Status",
  "Actions"
];

function DataFilter(props) {
  const {
    services,
    selectedService,
    setSelectedService,
    industries,
    selectedIndustry,
    setSelectedIndustry,
    status,
    setStatus,
    sortData,
    serviceContainerRef,
    industryContainerRef,
    handleServiceScroll,
    handleIndustryScroll,
  } = props;

  const [filterCollapse, setFilterCollapse] = useState(true);

  const statusData = [
    {
      name: "Contacted",
      id: 1,
      value: true,
    },
    {
      name: "Pending",
      id: 2,
      value: false,
    },
  ]

  const filterData = () => {
    sortData("", "", selectedIndustry?.id, selectedService?.id, status?.name);
    console.log("selectedIndustry ==>", selectedIndustry?.id)
    console.log("selectedService ==>", selectedService?.id)
    console.log("🚀 ~ filterData ~ status?.value:", status?.name)
  };

  const clearData = () => {
    setSelectedIndustry(null);
    setSelectedService(null);
    setStatus(null)
    sortData();
  };

  return (
    <Box sx={{ bgcolor: Colors.white, p: 2, borderRadius: "12px", mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1" fontWeight="bold" color="initial">
          Filters
        </Typography>
        <IconButton
          onClick={() => setFilterCollapse(!filterCollapse)}
          color="primary"
        >
          <FilterAltTwoTone sx={{ color: Colors.primary }} />
        </IconButton>
      </Box>

      <Collapse in={filterCollapse}>
        <Grid container spacing={2} alignItems={"flex-end"}>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                ref={serviceContainerRef}
                options={services}
                value={selectedService}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                onScroll={handleServiceScroll}
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setSelectedService({ name: newValue?.name, id: newValue?._id });
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Service"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                ref={industryContainerRef}
                options={industries}
                value={selectedIndustry}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                }
                onScroll={handleIndustryScroll}
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setSelectedIndustry({ name: newValue?.name, id: newValue?._id });
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Industry"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item md={4}>
            <FormControl fullWidth>
              <Autocomplete
                options={statusData}
                value={status}
                renderOption={(props, option) =>
                  <MenuItem {...props} key={option.id} value={option.value}>
                    {option.name}
                  </MenuItem>
                }
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) => {
                  if (newValue) {
                    // sortData("", "", "", "", "", newValue)
                    setStatus(newValue);
                    console.log("🚀 ~ DataFilter ~ newValue:", newValue)
                  } else if (newValue == null) {
                    setStatus(null);
                  }
                }}
                onClose={(event, reason) => {
                  if (reason) {
                    console.log("close")
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              onClick={clearData}
              variant="outlined"
              sx={{
                mx: 1,
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%), 
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Clear
            </Button>
            <Button
              onClick={filterData}
              variant="contained"
              sx={{
                textTransform: "capitalize",
                minWidth: "100px",
                boxShadow:
                  `0px 3px 1px -2px rgb(0 0 0 / 20%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%)`,
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
}

function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function AdProListing() {
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [servicePage, setServicePage] = useState(0);
  const [servicePerPage, setServicePerPage] = useState(10);
  const [industryPage, setIndustryPage] = useState(0);
  const [industryPerPage, setIndustryPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [adpros, setAdpros] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [status, setStatus] = useState(null)

  const serviceContainerRef = useRef();
  const industryContainerRef = useRef();
  const { state } = useLocation();
  const navigate = useNavigate();


  const getAllAdPros = async (page, rows, industry, service, status) => {
    console.log("🚀 ~ getAllAdPros ~ status:", status)
    setLoading(true);
    try {
      let result = await AdProServices.getAllAdPros(
        page ? page : 1,
        rows ? rows : 10,
        industry ? industry : "",
        service ? service : "",
        status ? status : "",
      );
      if (result.responseCode == 200) {
        console.log("result =>", result)
        // const arrayOfUsers = result?.data?.adpros?.map((item) => ({ name: item?.name, id: item?._id }));
        // console.log("🚀 ~ getAllUsers ~ arrayOfUsers:", arrayOfUsers)
        setAdpros(result?.data?.adpros);
        setCount(result?.data?.totalAdpros)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllAdPros(newPage + 1, rowsPerPage, selectedIndustry?.id, selectedService?.id, status?.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllAdPros(page, event.target.value, selectedIndustry?.id, selectedService?.id, status?.value);
  };

  const sort = (page, rows, industry, service, status) => {
    console.log("🚀 ~ sort ~ status:", status)
    getAllAdPros(page, rows, industry, service, status);
  }

  const getAllIndustries = async () => {
    try {
      let result = await IndustriesServices.getAllIndustries();
      setIndustries(result.data.industry);
    } catch (error) {
      console.log(error);
    }
  }

  const getAllServices = async () => {
    try {
      const result = await CategoriesServices.getAllCategories("", 1, 100, "adpro");
      setServices(result?.data?.categories)
    } catch (error) {
      console.log(error)
    }
  }

  const loadMoreServices = useCallback(() => {
    if (loading) return;
    setLoading(true);

    const newServices = services.slice((servicePage - 1) * servicePerPage, servicePage * servicePerPage);
    setServices(prevServices => [...prevServices, ...newServices]);

    setLoading(false);
  }, [servicePage, loading,]);

  const loadMoreIndustries = useCallback(() => {
    if (loading) return;
    setLoading(true);

    const newIndustries = industries.slice((industryPage - 1) * industryPerPage, industryPage * industryPerPage);
    setIndustries(prevIndustries => [...prevIndustries, ...newIndustries]);

    setLoading(false);
  }, [industryPage, loading,]);

  const handleServiceScroll = () => {
    if (!serviceContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = serviceContainerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5 && !loading) {
      setServicePage(prevPage => prevPage + 1);
    }
  };

  const handleIndustryScroll = () => {
    if (!industryContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = industryContainerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5 && !loading) {
      setIndustryPage(prevPage => prevPage + 1);
    }
  };

  const handleStatus = async () => {
    const obj = {
      isContacted: true
    };
    try {
      const result = await AdProServices.updateStatus(id, obj);
      if (result.responseCode == 200) {
        setOpen(false);
      }
    } catch (err) {
      console.log(err)
    } finally {
      getAllAdPros();
    }
  }

  useEffect(() => {
    loadMoreServices();
  }, [servicePage]);

  useEffect(() => {
    loadMoreIndustries();
  }, [industryPage]);

  useEffect(() => {
    getAllAdPros();
    getAllIndustries();
    getAllServices();
  }, [])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        borderRadius: "12px",
      }}
    >
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={handleStatus}
        title={"Update Status"}
        btn={"Update"}
      />
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Adpro
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Adpro"]} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <DataFilter
            services={services}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
            industries={industries}
            selectedIndustry={selectedIndustry}
            setSelectedIndustry={setSelectedIndustry}
            status={status}
            setStatus={setStatus}
            sortData={(page, rows, industry, service, status) => {
              console.log("🚀 ~ AdProListing ~ status:", status)
              sort(page, rows, industry, service, status)
            }
            }
            serviceContainerRef={serviceContainerRef}
            industryContainerRef={industryContainerRef}
            handleServiceScroll={handleServiceScroll}
            handleIndustryScroll={handleIndustryScroll}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Box>
            {loading ? (
              <CircleLoading />
            ) : (
              <Fragment>
                <TableContainer
                  component={Paper}
                  sx={{
                    // width: "calc(100vw - 320px)",
                    "&::-webkit-scrollbar": {
                      bgcolor: Colors.white,
                      height: "8px",
                      borderRadius: "10px",
                      cursor: "pointer",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      bgcolor: Colors.primary,
                      borderRadius: "10px",
                      cursor: "pointer",
                    },
                    "&.MuiPaper-root": {
                      borderRadius: "12px",
                      mt: 2,
                      boxShadow: 0,
                    },
                  }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow sx={{ bgcolor: Colors.lightGray }}>
                        {tableHead.map((item, index) => (
                          <TableCell key={index}>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                // textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                                width: "130px"
                              }}
                            >
                              {item}
                            </Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {adpros.map((row, index) => (
                        <TableRow
                          key={index}
                          // onClick={() => {
                          //   navigate("/proposals", { state: { id: row?._id } })
                          // }}
                          sx={{
                            transition: ".3s all ease-in-out",
                            ":hover": {
                              backgroundColor: Colors.primaryLight,
                              cursor: "pointer"
                            }
                          }}
                        >
                          <TableCell>
                            {row?.name}
                          </TableCell>
                          <TableCell>
                            {row?.phoneNumber}
                          </TableCell>
                          <TableCell>
                            {row?.email}
                          </TableCell>
                          <TableCell>
                            {(row?.service?.name ?? "-")}
                          </TableCell>
                          <TableCell>
                            {(row?.industry?.name ?? "-")}
                          </TableCell>
                          <TableCell
                            onClick={(e) => {
                              e.stopPropagation();
                              setId(row?._id)
                              setOpen(row?.isContacted == true ? false : true);
                            }}
                          >
                            <Chip
                              label={
                                row?.isContacted == true ? "Contacted" : "Pending"
                              }
                              sx={{
                                bgcolor: row?.isContacted == true ? Colors.success + 26 : Colors.pending + 26,
                                color: row?.isContacted == true ? Colors.success : Colors.pending,
                                height: 26,
                                textTransform: 'capitalize',
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box>
                              {/* <Tooltip title="Status">
                                <IconButton onClick={(e) => {
                                  
                                }}>
                                  <Edit sx={{ color: Colors.success }} />
                                </IconButton>
                              </Tooltip> */}
                              <Tooltip title="View">
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/adpro-details/${row?._id}`, {
                                      state: { data: row }
                                    });
                                  }}
                                >
                                  <RemoveRedEye sx={{ color: Colors.success }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Table sx={{ marginTop: "12px" }}>
                  <TablePagination
                    sx={{
                      borderBottom: "none",
                      bgcolor: Colors.white,
                      borderRadius: "12px",
                    }}
                    rowsPerPageOptions={[10, 20, 30]}
                    colSpan={12}
                    count={+count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </Table>
              </Fragment>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AdProListing